import { useEffect } from 'react';
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import { createCustomizationSchema } from '../validation';
import { CustomizationData, CreateCustomizationFormValues } from '../types';

const defaultValues: CreateCustomizationFormValues = {
  customization: '',
  note: '',
  quantityEnabled: false,
  minQuantity: null,
  maxQuantity: null,
  multipleSelections: false,
  multipleSelectionsQuantity: null,
  soldOut: false,
};

export const useCreateCustomizationForm = (
  open: boolean,
  onSubmit: (data: CustomizationData) => Promise<void>
) => {
  const { control, handleSubmit, watch, reset, trigger, formState: { errors, isSubmitting } } =
    useForm<CreateCustomizationFormValues>({
      resolver: yupResolver(createCustomizationSchema) as any,
      mode: 'onChange',
      defaultValues,
    });

  useEffect(() => {
    if (open) reset(defaultValues);
  }, [open, reset]);

  const quantityEnabled = watch('quantityEnabled');
  const multipleSelections = watch('multipleSelections');

  const onFormSubmit = async (values: CreateCustomizationFormValues) => {
    const data: CustomizationData = {
      customization: values.customization.trim(),
      note: values.note,
      options: [],
      enable_quantity_control: values.quantityEnabled,
      min_quantity: values.quantityEnabled ? values.minQuantity : null,
      max_quantity: values.quantityEnabled ? values.maxQuantity : null,
      multiple_selections: values.multipleSelections,
      multiple_selections_quantity: values.multipleSelections ? values.multipleSelectionsQuantity : null,
      sold_out: values.soldOut,
      related_items: [],
    };
    await onSubmit(data);
  };

  return {
    control,
    handleSubmit,
    trigger,
    errors,
    isSubmitting,
    quantityEnabled,
    multipleSelections,
    onFormSubmit,
  };
};
